<template>
    <div class="relative cursor-pointer" @click="goBig">
        <video ref="livestream" controls crossorigin playsinline :poster="this.poster"></video>

        <div v-if="overlay" class="absolute top-0 left-0 hidden lg:block w-full h-full bg-gradient-bl-black bg-opacity-40">
        </div>

        <div v-if="title"
            class="absolute bottom-0 right-0 left-0 hidden lg:block w-full container mt-6 lg:mt-0 px-10 text-center">
            <h1 class="lg:mb-10 text-5xl xl:text-6xl font-medium tracking-tight leading-none">
                {{ title }}
            </h1>
        </div>

        <div v-if="title" ref="controller"
            class="absolute bottom-0 inset-x-0 container hidden lg:flex justify-end px-10 pb-10">
            <magnetic :force="25" class="inline-flex">
                <button
                    class="w-6 h-6 text-white transition-transform duration-700 ease-out-quint transform hover:scale-150">
                    <svg fill="none" viewBox="0 0 24 24" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" class="w-full h-full fill-none">
                        <path d="m15 3h6v6" />
                        <path d="m9 21h-6v-6" />
                        <path d="m21 3-7 7" />
                        <path d="m3 21 7-7" />
                    </svg>
                </button>
            </magnetic>
        </div>
    </div>
</template>

<script>
import Plyr from 'plyr';
import Hls from 'hls.js';
import magnetic from '../components/Magnetic.vue';

export default {
    props: {
        source: String,
        poster: String,
        title: String,
        overlay: Boolean
    },

    components: {
        magnetic
    },

    data() {
        return {
            player: {},
            options: {
                controls: ['fullscreen'],
                autoplay: true,
                clickToPlay: false
            }
        };
    },
    mounted() {
        if (Hls.isSupported()) {
            const hls = new Hls();

            if (window.innerWidth >= 1024 && this.title) {
                this.options.controls = [''];
            }

            this.player = new Plyr(this.$refs.livestream, this.options);

            hls.loadSource(this.source);
            hls.attachMedia(this.$refs.livestream);
            window.hls = hls;

            hls.on(Hls.Events.MANIFEST_PARSED, this.controllerIn);
            this.$refs.livestream.muted = true;
            hls.on(Hls.Events.MANIFEST_PARSED, () => this.$refs.livestream.addEventListener('loadedmetadata', () => this.$refs.livestream.play()));
        } else if (this.$refs.livestream.canPlayType('application/vnd.apple.mpegurl')) {
            this.player = new Plyr(this.$refs.livestream, { controls: ['play-large', 'fullscreen'] });
            this.$refs.livestream.src = this.source;
            this.$refs.livestream.muted = true;
            this.$refs.livestream.addEventListener('loadedmetadata', function() {
                this.$refs.livestream.play();
            });
        }
    },

    methods: {
        controllerIn() {
            gsap.from(this.$refs.controller, {
                duration: 0.5,
                yPercent: 100,
                opacity: 0,
                delay: 0.8,
                ease: 'circ.inOut'
            });
        },
        goBig() {
            this.player.fullscreen.enter();
        }
    }
};
</script>
